import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { AccessDeniedComponent } from './access-denied.component';
import { RolePillsComponent } from './role-pills.component';
import { AUTH_API_ROOT, DRUPAL_SITE_URL, LOGIN_AUTH, LOGIN_CONFIG, LoginConfig } from './login.tokens';
import { AuthService } from '../auth/auth.service';
import { SsoCallbackComponent } from './sso-callback.component';

export interface LoginModuleOptions extends LoginConfig {
  apiRoot: string;
}

@NgModule({
  declarations: [LoginComponent, AccessDeniedComponent, RolePillsComponent, SsoCallbackComponent],
  imports: [
    CommonModule
  ],
  exports: [LoginComponent, AccessDeniedComponent, RolePillsComponent, SsoCallbackComponent]
})
export class LoginModule {
  static forRoot(options: LoginModuleOptions): ModuleWithProviders<LoginModule> {
    return {
      ngModule: LoginModule,
      providers: [
        { provide: LOGIN_CONFIG, useValue: {
          forgotPasswordUrl: options.forgotPasswordUrl,
          createAccountUrl: options.createAccountUrl,
          drupalSiteUrl: options.drupalSiteUrl
        }},
        { provide: AUTH_API_ROOT, useValue: options.apiRoot },
        { provide: DRUPAL_SITE_URL, useValue: options.drupalSiteUrl },
        { provide: LOGIN_AUTH, useExisting: AuthService }
      ]
    };
  }
}
